var map = {
	"./demo.config.js": 625,
	"./dev.config.js": 626,
	"./production.config.js": 627,
	"./test.config.js": 628
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 221;


//////////////////
// WEBPACK FOOTER
// ./src/config ^\.\/.*\.config\.js$
// module id = 221
// module chunks = 0